/**
 * Kopstorm x Dutchies product page blocks (31 Oct 2026)
 * ---------------------------------------------------------------------------
 * 1. <kop-pdp-addons>: the "Populaire add-ons" toggles (snippets/kop-pdp-addons.liquid)
 *    - switching an add-on on enables its hidden items[9x] inputs, so the theme's product form adds it as an extra
 *      line in the same add to cart call (assets/theme.js handles items[] posts)
 *    - add-ons with variants (a case per phone model) show a dropdown; the page model is preselected when the
 *      add-on has it, otherwise the dropdown is required before adding to cart
 *    - prices, the savings line and the add to cart total follow the selection and the variant on the page
 * 2. USP list: fills [amount] with the free shipping threshold in the shopper currency (snippets/kop-pdp-usps.liquid)
 */
(function () {
  'use strict';

  if (window.KopPdpBlocks) {
    return;
  }
  window.KopPdpBlocks = true;

  /* ------------------------------------------------------------------------
     Helpers
     ------------------------------------------------------------------------ */

  /* Money formatter built from a sample rendered by Shopify's money filter, so totals look exactly like the
     prices the server rendered (currency symbol, separators, position). */
  function createMoneyFormatter(sample) {
    if (typeof sample !== 'string' || !/\d/.test(sample)) {
      return function (cents) { return (cents / 100).toFixed(2); };
    }
    var first = sample.search(/\d/);
    var last = sample.length - 1;
    while (last >= 0 && !/\d/.test(sample.charAt(last))) { last -= 1; }
    var prefix = sample.slice(0, first);
    var suffix = sample.slice(last + 1);
    var core = sample.slice(first, last + 1);
    var separators = core.replace(/\d/g, '');
    var decimalSeparator = '';
    var groupSeparator = '';
    var decimals = 0;
    if (separators.length > 0) {
      var lastSeparator = separators.charAt(separators.length - 1);
      var digitsAfter = core.length - core.lastIndexOf(lastSeparator) - 1;
      if (digitsAfter === 2) {
        decimalSeparator = lastSeparator;
        decimals = 2;
        groupSeparator = separators.length > 1 ? separators.charAt(0) : '';
      } else {
        groupSeparator = lastSeparator;
      }
    }
    return function (cents) {
      var value = Math.round(Math.abs(cents));
      var units = decimals === 2 ? Math.floor(value / 100) : Math.round(value / 100);
      var body = String(units);
      if (groupSeparator) { body = body.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator); }
      if (decimals === 2) { body += decimalSeparator + String(value % 100).padStart(2, '0'); }
      return (cents < 0 ? '-' : '') + prefix + body + suffix;
    };
  }

  function stripZeros(text) {
    return text.replace(/[.,]00(?=\D*$)/, '');
  }

  function normalize(value) {
    return String(value == null ? '' : value).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function discounted(price, percent) {
    if (!percent || percent <= 0) { return price; }
    return Math.round((price * (100 - percent)) / 100);
  }

  function currencyRate() {
    var rate = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return rate > 0 ? rate : 1;
  }

  function readJson(element, fallback) {
    if (!element) { return fallback; }
    try { return JSON.parse(element.textContent || element); } catch (error) { return fallback; }
  }

  /* ------------------------------------------------------------------------
     Add to cart button total
     The button reads "In winkelwagen - €49,50". Only the text node holding the price is rewritten, so icons stay.
     The older Kopstorm add-on row and the gift wrap switch (.custom_upsells_item_input) are counted as well, so
     every script that touches the button writes the same total.
     ------------------------------------------------------------------------ */
  function findPriceTextNode(button) {
    var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.data.indexOf(' - ') !== -1) { return node; }
    }
    return null;
  }

  function updateButtons(formId) {
    var boxes = Array.prototype.slice.call(document.querySelectorAll('kop-pdp-addons[form="' + formId + '"]'));
    if (!boxes.length) { return; }
    var box = boxes[0];
    var base = parseInt(box.getAttribute('data-base-price'), 10);
    if (isNaN(base)) { return; }

    var total = base;
    boxes.forEach(function (element) { total += element.selectedTotal(); });

    document.querySelectorAll('.custom_upsells_item_input').forEach(function (input) {
      if (!input.checked || input.closest('[hidden]')) { return; }
      var host = input.closest('kop-addon-upsell');
      if (host && host.getAttribute('form') !== formId) { return; }
      var extra = parseInt(input.getAttribute('data-product-price'), 10);
      if (!isNaN(extra)) { total += extra; }
    });

    document.querySelectorAll('buy-buttons[form="' + formId + '"] button[type="submit"]').forEach(function (button) {
      if (!button.closest('.product-info__block-item')) { return; }
      var textNode = findPriceTextNode(button);
      if (!textNode) { return; }
      var label = button.getAttribute('data-kop-atc-label');
      if (label === null) {
        label = textNode.data.slice(0, textNode.data.lastIndexOf(' - '));
        button.setAttribute('data-kop-atc-label', label);
      }
      var next = label + ' - ' + box.formatMoney(total);
      if (textNode.data !== next) { textNode.data = next; }
    });
  }

  var pendingForms = {};
  function scheduleButtons(formId) {
    if (!formId || pendingForms[formId]) { return; }
    pendingForms[formId] = true;
    /* Runs after the older add-on script, which rewrites the same button on the same events */
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        pendingForms[formId] = false;
        updateButtons(formId);
      }, 0);
    });
  }

  /* ------------------------------------------------------------------------
     <kop-pdp-addons>
     ------------------------------------------------------------------------ */
  var KopPdpAddons = class extends HTMLElement {
    connectedCallback() {
      if (this.__kopReady) { return; }
      this.__kopReady = true;

      this.formId = this.getAttribute('form');
      this.discount = parseInt(this.getAttribute('data-discount'), 10) || 0;
      this.formatMoney = createMoneyFormatter(this.getAttribute('data-money-sample'));
      this.pageModelIndex = parseInt(this.getAttribute('data-page-model-index'), 10);
      this.pageOptions = readJson(this.getAttribute('data-page-options'), []);
      this.savingsElement = this.querySelector('[data-kop-addons-savings]');

      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-kop-addon]')).map(this.setupItem, this);

      var more = this.querySelector('[data-kop-addons-more]');
      if (more) {
        var moreLabel = more.querySelector('[data-kop-addons-more-label]');
        more.addEventListener('click', function () {
          var expand = more.getAttribute('aria-expanded') !== 'true';
          /* Collapsing keeps extra add-ons that are switched on in view, so nothing in the total disappears */
          this.querySelectorAll('.kop-pdp-addon--extra').forEach(function (item) {
            var on = item.querySelector('[data-kop-addon-input]');
            item.hidden = !expand && !(on && on.checked);
          });
          more.setAttribute('aria-expanded', expand ? 'true' : 'false');
          if (moreLabel) {
            moreLabel.textContent = more.getAttribute(expand ? 'data-label-less' : 'data-label-more') || moreLabel.textContent;
          }
        }.bind(this));
      }

      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('variant:change', this.onVariantChange);

      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
      this.__kopReady = false;
    }

    setupItem(element) {
      var item = {
        element: element,
        input: element.querySelector('[data-kop-addon-input]'),
        select: element.querySelector('[data-kop-addon-select]'),
        choice: element.querySelector('[data-kop-addon-choice]'),
        priceElement: element.querySelector('[data-kop-addon-price]'),
        compareElement: element.querySelector('[data-kop-addon-compare]'),
        image: element.querySelector('.kop-pdp-addon__img img'),
        fields: Array.prototype.slice.call(element.querySelectorAll('[data-kop-addon-field]')),
        idField: element.querySelector('[data-kop-addon-field="id"]'),
        forField: element.querySelector('[data-kop-addon-field="for"]'),
        variants: readJson(element.querySelector('[data-kop-addon-variants]'), []),
        modelIndex: parseInt(element.getAttribute('data-model-index'), 10),
        touched: false
      };

      item.input.addEventListener('change', function () {
        this.syncItem(item);
        this.refresh();
      }.bind(this));

      if (item.select) {
        item.select.addEventListener('change', function () {
          item.touched = true;
          this.syncItem(item);
          this.refresh();
        }.bind(this));
      }

      var info = element.querySelector('[data-kop-addon-info]');
      var detail = element.querySelector('[data-kop-addon-detail]');
      if (info && detail) {
        info.addEventListener('click', function () {
          var open = detail.hidden;
          detail.hidden = !open;
          info.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      return item;
    }

    variantById(item, id) {
      for (var i = 0; i < item.variants.length; i++) {
        if (String(item.variants[i].id) === String(id)) { return item.variants[i]; }
      }
      return null;
    }

    firstAvailable(item) {
      for (var i = 0; i < item.variants.length; i++) {
        if (item.variants[i].available) { return item.variants[i]; }
      }
      return null;
    }

    /* The add-on variant that belongs with the variant on the page (same phone model) */
    matchingVariant(item) {
      if (item.modelIndex < 0 || this.pageModelIndex < 0) { return null; }
      var wanted = normalize(this.pageOptions[this.pageModelIndex]);
      if (!wanted) { return null; }
      for (var i = 0; i < item.variants.length; i++) {
        var variant = item.variants[i];
        if (variant.available && normalize((variant.options || [])[item.modelIndex]) === wanted) { return variant; }
      }
      return null;
    }

    /* Variant used for the price: the chosen one, else the first available one (same as the Liquid first paint) */
    displayVariant(item) {
      var chosen = item.select ? this.variantById(item, item.select.value) : item.variants[0];
      return chosen || this.firstAvailable(item) || item.variants[0] || null;
    }

    chosenVariant(item) {
      if (!item.select) { return item.variants[0] || null; }
      var variant = this.variantById(item, item.select.value);
      return variant && variant.available ? variant : null;
    }

    syncItem(item) {
      var on = item.input.checked;
      var chosen = this.chosenVariant(item);

      if (item.choice) {
        item.choice.hidden = !on;
        item.select.required = on;
        /* The browser stops the add to cart on this dropdown and shows "Kies je model" */
        item.select.setCustomValidity(on && !chosen ? item.select.getAttribute('aria-label') || '' : '');
      }

      item.element.classList.toggle('is-selected', on);

      /* Hidden inputs only post while the add-on is on and a variant is chosen */
      item.fields.forEach(function (field) { field.disabled = !(on && chosen); });
      if (item.idField) { item.idField.value = chosen ? chosen.id : ''; }

      var display = chosen || this.displayVariant(item);
      if (!display) { return; }

      var final = discounted(display.price, this.discount);
      var reference = Math.max(display.price, display.compare || 0);

      if (item.priceElement) { item.priceElement.textContent = this.formatMoney(final); }
      if (item.compareElement) {
        if (reference > final) {
          item.compareElement.textContent = this.formatMoney(reference);
          item.compareElement.hidden = false;
        } else {
          item.compareElement.textContent = '';
          item.compareElement.hidden = true;
        }
      }

      if (item.image && chosen && chosen.image && item.image.getAttribute('src') !== chosen.image) {
        item.image.removeAttribute('srcset');
        item.image.setAttribute('src', chosen.image);
      }
    }

    /* Page variant changed: carry the new model over to add-ons the shopper did not set by hand */
    onVariantChange(event) {
      /* form.id would return the input named "id", so the attribute is read instead */
      var form = event.target;
      if (!form || !form.getAttribute || form.getAttribute('id') !== this.formId) { return; }
      var variant = event.detail && event.detail.variant;
      if (!variant) { return; }

      if (typeof variant.price === 'number') { this.setAttribute('data-base-price', variant.price); }
      if (Array.isArray(variant.options)) { this.pageOptions = variant.options; }

      this.items.forEach(function (item) {
        if (item.forField) { item.forField.value = variant.id; }
        if (item.select && !item.touched && item.modelIndex >= 0) {
          var match = this.matchingVariant(item);
          item.select.value = match ? String(match.id) : '';
        }
        this.syncItem(item);
      }, this);

      this.refresh();
    }

    selectedTotal() {
      var total = 0;
      (this.items || []).forEach(function (item) {
        if (!item.input.checked) { return; }
        var chosen = this.chosenVariant(item);
        if (chosen) { total += discounted(chosen.price, this.discount); }
      }, this);
      return total;
    }

    selectedSavings() {
      var savings = 0;
      (this.items || []).forEach(function (item) {
        if (!item.input.checked) { return; }
        var chosen = this.chosenVariant(item);
        if (!chosen) { return; }
        var reference = Math.max(chosen.price, chosen.compare || 0);
        savings += reference - discounted(chosen.price, this.discount);
      }, this);
      return savings;
    }

    refresh() {
      this.items.forEach(this.syncItem, this);

      if (this.savingsElement) {
        var savings = this.selectedSavings();
        if (savings > 0) {
          var template = this.savingsElement.getAttribute('data-template') || '';
          this.savingsElement.textContent = template.replace('[amount]', this.formatMoney(savings));
          this.savingsElement.hidden = false;
        } else {
          this.savingsElement.hidden = true;
        }
      }

      scheduleButtons(this.formId);
    }
  };

  if (!window.customElements.get('kop-pdp-addons')) {
    window.customElements.define('kop-pdp-addons', KopPdpAddons);
  }

  /* Other scripts that change the total: the older add-on row, the gift wrap and the theme swapping the buttons */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.classList && target.classList.contains('custom_upsells_item_input')) {
      document.querySelectorAll('kop-pdp-addons').forEach(function (box) { scheduleButtons(box.getAttribute('form')); });
    }
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) { return; }
          var buttons = node.matches && node.matches('buy-buttons') ? [node] : (node.querySelectorAll ? Array.prototype.slice.call(node.querySelectorAll('buy-buttons')) : []);
          buttons.forEach(function (element) { scheduleButtons(element.getAttribute('form')); });
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------------
     USP list: [amount] = free shipping threshold in the shopper currency
     ------------------------------------------------------------------------ */
  function drawerShippingCents() {
    var bar = document.querySelector('kop-rewards-bar[data-context="drawer"]');
    if (!bar) { return null; }
    var node = bar.querySelector('.kop-rewards-bar__node[data-kop-kind="shipping"]');
    if (!node) { return null; }
    var cents = parseInt(node.getAttribute('data-kop-node'), 10);
    return cents > 0 ? cents : null;
  }

  function fillUsps() {
    document.querySelectorAll('[data-kop-usps]').forEach(function (list) {
      var format = createMoneyFormatter(list.getAttribute('data-money-sample'));
      var fromDrawer = list.getAttribute('data-follow-drawer') === 'true' ? drawerShippingCents() : null;
      list.querySelectorAll('[data-kop-usp-amount]').forEach(function (span) {
        var cents = fromDrawer;
        if (cents === null) {
          cents = parseInt(span.getAttribute('data-cents'), 10) || 0;
          if (span.getAttribute('data-convert') === '1') { cents = Math.round(cents * currencyRate()); }
        }
        var text = stripZeros(format(cents));
        if (span.textContent !== text) { span.textContent = text; }
      });
    });
  }

  function bootUsps() {
    fillUsps();
    /* The drawer bar converts its tiers once kop-rewards-bar.js has run */
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('kop-rewards-bar').then(function () { window.setTimeout(fillUsps, 0); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootUsps);
  } else {
    bootUsps();
  }
  window.addEventListener('load', fillUsps);
  document.addEventListener('shopify:section:load', fillUsps);
})();
